







import { Component, Prop, Vue } from 'vue-property-decorator'
import { RoomMember } from '@/class/roomMember'
import Qr from '@/components/Utils/Qr.vue'
import HeadlineBorder from '@/components/Utils/headline/HeadlineBorder.vue'

@Component({
  components: {
    Qr,
    HeadlineBorder
  }
})
export default class GlobalMenu extends Vue {
  @Prop() self!: RoomMember;

  get url () {
    return location.href
  }
}
